import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ModalRendererComponent } from '../../widgets/modal-renderer/modal-renderer.component';

@Component({
    selector: 'app-open-modal',
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        ModalRendererComponent,
    ],
    templateUrl: './open-modal.component.html',
    styleUrl: './open-modal.component.css'
})
export class OpenModalComponent {
  @Input() context: any;
  @Input() disableBackdropClick: boolean = false;
  @Output() close = new EventEmitter<void>();
  @Output() formSaved = new EventEmitter<any>();
  @ViewChild('addModalRenderer') addModalRenderer!: ModalRendererComponent;
  modalTitle: any;
  setModalTitle(title: string) {
    this.modalTitle = title;
  }

  onModalFormSaved(event: any): void {
    if (!event?.success) return;

    this.formSaved.emit(event);
    this.closeModal();
  }

  @HostListener('document:keydown.escape')
  handleEscapeKey(): void {
    this.closeModal();
  }

  onBackdropClick(): void {
    if (!this.disableBackdropClick) {
      this.closeModal();
    }
  }

  closeModal(): void {
    this.addModalRenderer?.resetForms();
    this.close.emit();
  }
}
